import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout, Avatar, Dropdown, Button, Space, Typography } from 'antd';
import {
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
  BellOutlined,
} from '@ant-design/icons';
import { logout } from '../features/auth/authSlice';
import { setMenuData } from '../features/menu/menuSlice';
import GlobalNotification from './GlobalNotification';
import DynamicMenu from './DynamicMenu';
import { useWebSocket } from '../contexts/WebSocketContext';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

const AppLayout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const menuData = useSelector((state) => state.menu);
  const { isConnected } = useWebSocket();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const handleMenuLoad = (data) => {
    // 将菜单和权限信息存储到 Redux
    dispatch(setMenuData(data));
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人资料',
      onClick: () => navigate('/profile'),
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '系统设置',
      onClick: () => navigate('/settings'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];



  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* 全局 WebSocket 通知 */}
      <GlobalNotification />
      
      <Sider
        width={240}
        style={{
          background: '#fff',
          boxShadow: '2px 0 8px rgba(0, 0, 0, 0.1)',
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
        }}
      >
        <div style={{
          height: '64px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid #f0f0f0',
          marginBottom: '16px'
        }}>
          <Text strong style={{ fontSize: '18px', color: '#1890ff' }}>
            金融后台管理系统
          </Text>
        </div>
        
        <DynamicMenu onMenuLoad={handleMenuLoad} />
      </Sider>

      <Layout style={{ marginLeft: 240 }}>
        <Header style={{
          background: '#fff',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          position: 'fixed',
          width: 'calc(100% - 240px)',
          zIndex: 1,
        }}>
          <div>
            <Text strong style={{ fontSize: '16px' }}>
              {menuData?.role === 'super_admin' ? '超级管理员' : 
               menuData?.role === 'admin' ? '管理员' : 
               menuData?.role === 'operator' ? '操作员' : ''}控制台
            </Text>
          </div>

          <Space size="middle">
            <Button type="text" icon={<BellOutlined />} />
            
            {/* WebSocket 连接状态 */}
            <Space size="small" style={{ 
              padding: '4px 12px', 
              borderRadius: '4px',
              background: isConnected ? '#f6ffed' : '#fff1f0',
              border: `1px solid ${isConnected ? '#b7eb8f' : '#ffccc7'}`
            }}>
              <BellOutlined style={{ 
                fontSize: '14px', 
                color: isConnected ? '#52c41a' : '#ff4d4f' 
              }} />
              <Text style={{ 
                fontSize: '12px', 
                color: isConnected ? '#52c41a' : '#ff4d4f' 
              }}>
                {isConnected ? '实时通知' : '未连接'}
              </Text>
            </Space>
            
            <Dropdown
              menu={{ items: userMenuItems }}
              placement="bottomRight"
              arrow
            >
              <Space style={{ cursor: 'pointer' }}>
                <Avatar
                  size="small"
                  icon={<UserOutlined />}
                  src={user?.avatar}
                />
                <Text>{user?.name || user?.phone}</Text>
              </Space>
            </Dropdown>
          </Space>
        </Header>

        <Content style={{
          margin: '88px 24px 24px',
          padding: '24px',
          background: '#fff',
          borderRadius: '8px',
          minHeight: 'calc(100vh - 136px)',
          overflow: 'auto',
        }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;